import React, { useCallback, useMemo, useState as useState$1, memo, useEffect, createContext, useContext, useRef } from 'react';
import head from 'lodash-es/head';
import { useSelector, useDispatch, Provider } from 'react-redux';
import { createAsyncThunk, createSlice, createEntityAdapter, createSelector, configureStore } from '@reduxjs/toolkit';
import partition from 'lodash-es/partition';
import { chainFrom } from 'transducist';
import { schema, normalize } from 'normalizr';
import axios from 'axios';
import last from 'lodash-es/last';
import memoize from 'lodash-es/memoize';
import { useQuery } from 'react-query';
import useWebSocket from 'react-use-websocket';
import map from 'lodash-es/map';
import range from 'lodash-es/range';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useTab = function useTab(_ref) {
  var activeTab = _ref.activeTab,
      setActiveTab = _ref.setActiveTab;
  return function (tab) {
    if (tab === undefined) {
      throw new Error("Missing 'tab'");
    }

    var onTabClick = useCallback(function () {
      tab && setActiveTab(tab);
    }, [setActiveTab, tab]);
    var isTabActive = useMemo(function () {
      return tab === activeTab;
    }, [tab, activeTab]);
    return {
      name: tab,
      onClick: function onClick() {
        return onTabClick();
      },
      isActive: isTabActive,
      'data-active': isTabActive
    };
  };
};

var useTabs = function useTabs(_ref2) {
  var tabs = _ref2.tabs,
      activeTab = _ref2.activeTab,
      setActiveTab = _ref2.setActiveTab;
  var makeTabs = useTab({
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });
  var tabsList = tabs.map(makeTabs);
  return tabsList;
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var SESSION = 'X-ODDS-SESSION';
var LANG = 'Request-Language';
var http = /*#__PURE__*/axios.create({
  baseURL: process.env.DOMAIN_URL
});
var https = {
  get: function get(url, session, lang) {
    var _ref, _ref2;

    return http.get(url, {
      headers: _extends({}, session && (_ref = {}, _ref[SESSION] = session, _ref), lang && (_ref2 = {}, _ref2[LANG] = lang, _ref2))
    });
  },
  post: function post(url, data, session, lang) {
    var _ref3, _ref4;

    return http.post(url, data, {
      headers: _extends({}, session && (_ref3 = {}, _ref3[SESSION] = session, _ref3), lang && (_ref4 = {}, _ref4[LANG] = lang, _ref4))
    });
  }
};

var getSeasonalEvents = function getSeasonalEvents(_ref) {
  var _ref$session = _ref.session,
      session = _ref$session === void 0 ? '' : _ref$session,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'en' : _ref$lang;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2) {
      var product, season, day;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              product = _ref2.product, season = _ref2.season, day = _ref2.day;
              return _context.abrupt("return", https.get("virtuals-api/rest/virtuals/v1/api/br/seasonal/" + product + "/" + season + "/" + day, session, lang));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getSportEvents = function getSportEvents(_ref7) {
  var _ref7$session = _ref7.session,
      session = _ref7$session === void 0 ? undefined : _ref7$session,
      _ref7$lang = _ref7.lang,
      lang = _ref7$lang === void 0 ? 'pl' : _ref7$lang;
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(_ref8) {
      var product, eventId;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              product = _ref8.product, eventId = _ref8.eventId;
              return _context3.abrupt("return", https.get("/virtuals-api/rest/virtuals/v1/api/br/sports/" + product + "/" + eventId, session, lang));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var outcome = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome]
}, {
  idAttribute: 'gameId'
});
var event = /*#__PURE__*/new schema.Entity('events', {
  games: [game]
}, {
  idAttribute: 'eventId'
});

var entityFetch = /*#__PURE__*/createAsyncThunk('vflm/fetch', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var _ref$product, product, season, day, _yield$getSeasonalEve, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$product = _ref.product, product = _ref$product === void 0 ? 'vflm' : _ref$product, season = _ref.season, day = _ref.day;
            _context.next = 3;
            return getSeasonalEvents({})({
              product: product,
              season: season,
              day: day
            });

          case 3:
            _yield$getSeasonalEve = _context.sent;
            data = _yield$getSeasonalEve.data;
            _normalize = normalize(data == null ? void 0 : data.data, [event]), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

var VFLM_EVENTS = 'vflm/events';
var entity = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice = /*#__PURE__*/createSlice({
  name: VFLM_EVENTS,
  initialState: /*#__PURE__*/entity.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch.fulfilled, function (state, action) {
      action.payload.events && entity.setAll(state, action.payload.events);
    });
  }
});

var getEventsState = function getEventsState(state) {
  return state[VFLM_EVENTS];
};

var _entity$getSelectors = /*#__PURE__*/entity.getSelectors(getEventsState),
    selectAllEvents = _entity$getSelectors.selectAll;

var VFLM_GAMES = 'vflm/games';
var entity$1 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  },
  sortComparer: function sortComparer(a, b) {
    return a.sortOrder - b.sortOrder;
  }
});
var slice$1 = /*#__PURE__*/createSlice({
  name: VFLM_GAMES,
  initialState: /*#__PURE__*/entity$1.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch.fulfilled, function (state, action) {
      action.payload.games && entity$1.setAll(state, action.payload.games);
    });
  }
});

var _entity$getSelectors$1 = /*#__PURE__*/entity$1.getSelectors(function (state) {
  return state[VFLM_GAMES];
}),
    selectAllGames = _entity$getSelectors$1.selectAll;

var VFLM_OUTCOMES = 'vflm/outcomes';
var entity$2 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$2 = /*#__PURE__*/createSlice({
  name: VFLM_OUTCOMES,
  initialState: /*#__PURE__*/entity$2.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch.fulfilled, function (state, action) {
      action.payload.outcomes && entity$2.setAll(state, action.payload.outcomes);
    });
  }
});

var _entity$getSelectors$2 = /*#__PURE__*/entity$2.getSelectors(function (state) {
  return state[VFLM_OUTCOMES];
}),
    selectAllOutcomes = _entity$getSelectors$2.selectAll;

var VFLM_SELECTION = 'vflm/selection';
var entity$3 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var accessor = _ref.accessor;
    return accessor;
  }
});
var slice$3 = /*#__PURE__*/createSlice({
  name: VFLM_SELECTION,
  initialState: /*#__PURE__*/entity$3.getInitialState(),
  reducers: {
    setAllSelections: entity$3.setAll
  }
});

var getSelectionState = function getSelectionState(state) {
  return state[VFLM_SELECTION];
};

var setAllSelections = slice$3.actions.setAllSelections;

var _entity$getSelectors$3 = /*#__PURE__*/entity$3.getSelectors(getSelectionState),
    selectSelection = _entity$getSelectors$3.selectAll;

var _excluded = ["games"],
    _excluded2 = ["gameOutcomes"];
var getEvents = /*#__PURE__*/createSelector(selectAllEvents, function (events) {
  return events;
});
var getIsSingleEvent = /*#__PURE__*/createSelector(getEvents, function (events) {
  return events.length === 1;
});
var getEventGames = function getEventGames(_ref, matchDay) {
  var games = _ref.games,
      event = _objectWithoutPropertiesLoose(_ref, _excluded);

  return createSelector([selectAllGames, selectSelection], function (allGames, selection) {
    return partition(chainFrom(allGames).filter(function (game) {
      return games.some(function (gameId) {
        return gameId === game.gameId;
      });
    }).filter(function (game) {
      return game.matchday ? game.matchday === matchDay : true;
    }).map(function (game) {
      return _extends({}, event, game);
    }).toArray(), function (game) {
      return selection.some(function (_ref2) {
        var accessor = _ref2.accessor,
            argument = _ref2.argument;
        return argument ? game.gameTypeId === accessor && game.argument === argument : game.gameTypeId === accessor;
      });
    });
  });
};
var getGameOutcomes = function getGameOutcomes(_ref3) {
  var outcomes = _ref3.gameOutcomes,
      game = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  return createSelector([selectAllOutcomes], function (allOutcomes) {
    return chainFrom(allOutcomes).filter(function (outcome) {
      return outcomes.some(function (outcomeId) {
        return outcomeId === outcome.outcomeId;
      });
    }).map(function (outcome) {
      return _extends({}, game, outcome, {
        gameStatus: game.status
      });
    }).toArray();
  });
};

var outcome$1 = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game$1 = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome$1]
}, {
  idAttribute: 'gameId'
});
var event$1 = /*#__PURE__*/new schema.Entity('event', {
  games: [game$1]
}, {
  idAttribute: 'eventId'
});

var entityFetch$1 = /*#__PURE__*/createAsyncThunk('vdk/fetch', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var _ref$product, product, eventId, _yield$getSportEvents, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$product = _ref.product, product = _ref$product === void 0 ? 'vdk' : _ref$product, eventId = _ref.eventId;
            _context.next = 3;
            return getSportEvents({})({
              product: product,
              eventId: eventId
            });

          case 3:
            _yield$getSportEvents = _context.sent;
            data = _yield$getSportEvents.data;
            _normalize = normalize(data == null ? void 0 : data.data, event$1), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

var VDK_EVENTS = 'vdk/events';
var entity$4 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice$4 = /*#__PURE__*/createSlice({
  name: VDK_EVENTS,
  initialState: /*#__PURE__*/entity$4.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$1.fulfilled, function (state, action) {
      action.payload.event && entity$4.setAll(state, action.payload.event);
    });
  }
});

var getEventsState$1 = function getEventsState(state) {
  return state[VDK_EVENTS];
};

var _entity$getSelectors$4 = /*#__PURE__*/entity$4.getSelectors(getEventsState$1),
    selectAllEvents$1 = _entity$getSelectors$4.selectAll;

var VDK_GAMES = 'vdk/games';
var entity$5 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  }
});
var slice$5 = /*#__PURE__*/createSlice({
  name: VDK_GAMES,
  initialState: /*#__PURE__*/entity$5.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$1.fulfilled, function (state, action) {
      action.payload.games && entity$5.setAll(state, action.payload.games);
    });
  }
});

var _entity$getSelectors$5 = /*#__PURE__*/entity$5.getSelectors(function (state) {
  return state[VDK_GAMES];
}),
    selectAllGames$1 = _entity$getSelectors$5.selectAll;

var VDK_OUTCOMES = 'vdk/outcomes';
var entity$6 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$6 = /*#__PURE__*/createSlice({
  name: VDK_OUTCOMES,
  initialState: /*#__PURE__*/entity$6.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$1.fulfilled, function (state, action) {
      action.payload.outcomes && entity$6.setAll(state, action.payload.outcomes);
    });
  }
});

var _entity$getSelectors$6 = /*#__PURE__*/entity$6.getSelectors(function (state) {
  return state[VDK_OUTCOMES];
}),
    selectAllOutcomes$1 = _entity$getSelectors$6.selectAll;

var outcome$2 = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game$2 = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome$2]
}, {
  idAttribute: 'gameId'
});
var event$2 = /*#__PURE__*/new schema.Entity('event', {
  games: [game$2]
}, {
  idAttribute: 'eventId'
});

var entityFetch$2 = /*#__PURE__*/createAsyncThunk('vhk/fetch', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var _ref$product, product, eventId, _yield$getSportEvents, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$product = _ref.product, product = _ref$product === void 0 ? 'vhk' : _ref$product, eventId = _ref.eventId;
            _context.next = 3;
            return getSportEvents({})({
              product: product,
              eventId: eventId
            });

          case 3:
            _yield$getSportEvents = _context.sent;
            data = _yield$getSportEvents.data;
            _normalize = normalize(data == null ? void 0 : data.data, event$2), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

var VHK_EVENTS = 'vhk/events';
var entity$7 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice$7 = /*#__PURE__*/createSlice({
  name: VHK_EVENTS,
  initialState: /*#__PURE__*/entity$7.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$2.fulfilled, function (state, action) {
      action.payload.event && entity$7.setAll(state, action.payload.event);
    });
  }
});

var getEventsState$2 = function getEventsState(state) {
  return state[VHK_EVENTS];
};

var _entity$getSelectors$7 = /*#__PURE__*/entity$7.getSelectors(getEventsState$2),
    selectAllEvents$2 = _entity$getSelectors$7.selectAll;

var VHK_GAMES = 'vhk/games';
var entity$8 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  }
});
var slice$8 = /*#__PURE__*/createSlice({
  name: VHK_GAMES,
  initialState: /*#__PURE__*/entity$8.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$2.fulfilled, function (state, action) {
      action.payload.games && entity$8.setAll(state, action.payload.games);
    });
  }
});

var _entity$getSelectors$8 = /*#__PURE__*/entity$8.getSelectors(function (state) {
  return state[VHK_GAMES];
}),
    selectAllGames$2 = _entity$getSelectors$8.selectAll;

var VHK_OUTCOMES = 'vhk/outcomes';
var entity$9 = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$9 = /*#__PURE__*/createSlice({
  name: VHK_OUTCOMES,
  initialState: /*#__PURE__*/entity$9.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$2.fulfilled, function (state, action) {
      action.payload.outcomes && entity$9.setAll(state, action.payload.outcomes);
    });
  }
});

var _entity$getSelectors$9 = /*#__PURE__*/entity$9.getSelectors(function (state) {
  return state[VHK_OUTCOMES];
}),
    selectAllOutcomes$2 = _entity$getSelectors$9.selectAll;

var getOutcomes = function getOutcomes(_ref) {
  var _ref$session = _ref.session,
      session = _ref$session === void 0 ? '' : _ref$session,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'en' : _ref$lang;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2) {
      var remoteEventId, remoteGameId, remoteOutcomeType, selectionKey, specifiers;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              remoteEventId = _ref2.remoteEventId, remoteGameId = _ref2.remoteGameId, remoteOutcomeType = _ref2.remoteOutcomeType, selectionKey = _ref2.selectionKey, specifiers = _ref2.specifiers;
              return _context.abrupt("return", https.post("/rest/market/events/virtual/uof/outcomes", [{
                remoteEventId: remoteEventId,
                remoteGameId: remoteGameId,
                remoteOutcomeType: remoteOutcomeType,
                selectionKey: selectionKey,
                specifiers: specifiers
              }], session, lang));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var outcome$3 = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game$3 = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome$3]
}, {
  idAttribute: 'gameId'
});
var event$3 = /*#__PURE__*/new schema.Entity('events', {
  games: [game$3]
}, {
  idAttribute: 'eventId'
});

var entityFetch$3 = /*#__PURE__*/createAsyncThunk('vbl/fetch', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var _ref$product, product, season, day, _yield$getSeasonalEve, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$product = _ref.product, product = _ref$product === void 0 ? 'vbl' : _ref$product, season = _ref.season, day = _ref.day;
            _context.next = 3;
            return getSeasonalEvents({})({
              product: product,
              season: season,
              day: day
            });

          case 3:
            _yield$getSeasonalEve = _context.sent;
            data = _yield$getSeasonalEve.data;
            _normalize = normalize(data == null ? void 0 : data.data, [event$3]), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
var fetchOutcome = /*#__PURE__*/createAsyncThunk('vbl/custom', /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(bet) {
    var _yield$getOutcomes, data;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getOutcomes({
              session: ''
            })(bet);

          case 2:
            _yield$getOutcomes = _context2.sent;
            data = _yield$getOutcomes.data;
            return _context2.abrupt("return", head(data == null ? void 0 : data.data));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}());

var VBL_EVENTS = 'vbl/events';
var entity$a = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice$a = /*#__PURE__*/createSlice({
  name: VBL_EVENTS,
  initialState: /*#__PURE__*/entity$a.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$3.fulfilled, function (state, action) {
      action.payload.events && entity$a.setAll(state, action.payload.events);
    });
  }
});

var getEventsState$3 = function getEventsState(state) {
  return state[VBL_EVENTS];
};

var _entity$getSelectors$a = /*#__PURE__*/entity$a.getSelectors(getEventsState$3),
    selectAllEvents$3 = _entity$getSelectors$a.selectAll;

var VBL_GAMES = 'vbl/games';
var entity$b = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  }
});
var slice$b = /*#__PURE__*/createSlice({
  name: VBL_GAMES,
  initialState: /*#__PURE__*/entity$b.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$3.fulfilled, function (state, action) {
      action.payload.games && entity$b.setAll(state, action.payload.games);
    });
  }
});

var _entity$getSelectors$b = /*#__PURE__*/entity$b.getSelectors(function (state) {
  return state[VBL_GAMES];
}),
    selectAllGames$3 = _entity$getSelectors$b.selectAll;

var VBL_OUTCOMES = 'vbl/outcomes';
var entity$c = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$c = /*#__PURE__*/createSlice({
  name: VBL_OUTCOMES,
  initialState: /*#__PURE__*/entity$c.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$3.fulfilled, function (state, action) {
      action.payload.outcomes && entity$c.setAll(state, action.payload.outcomes);
    });
  }
});

var _entity$getSelectors$c = /*#__PURE__*/entity$c.getSelectors(function (state) {
  return state[VBL_OUTCOMES];
}),
    selectAllOutcomes$3 = _entity$getSelectors$c.selectAll;

var VFEC_SELECTION = 'vfec/selection';
var entity$d = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var accessor = _ref.accessor;
    return accessor;
  }
});
var slice$d = /*#__PURE__*/createSlice({
  name: VFEC_SELECTION,
  initialState: /*#__PURE__*/entity$d.getInitialState(),
  reducers: {
    setAllSelections: entity$d.setAll
  }
});

var getSelectionState$1 = function getSelectionState(state) {
  return state[VFEC_SELECTION];
};

var setAllSelections$1 = slice$d.actions.setAllSelections;

var _entity$getSelectors$d = /*#__PURE__*/entity$d.getSelectors(getSelectionState$1),
    selectSelection$1 = _entity$getSelectors$d.selectAll;

var outcome$4 = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game$4 = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome$4]
}, {
  idAttribute: 'gameId'
});
var event$4 = /*#__PURE__*/new schema.Entity('events', {
  games: [game$4]
}, {
  idAttribute: 'eventId'
});

var entityFetch$4 = /*#__PURE__*/createAsyncThunk('vfec/fetch', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var _ref$product, product, season, day, _yield$getSeasonalEve, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$product = _ref.product, product = _ref$product === void 0 ? 'vfec' : _ref$product, season = _ref.season, day = _ref.day;
            _context.next = 3;
            return getSeasonalEvents({})({
              product: product,
              season: season,
              day: day
            });

          case 3:
            _yield$getSeasonalEve = _context.sent;
            data = _yield$getSeasonalEve.data;
            _normalize = normalize(data == null ? void 0 : data.data, [event$4]), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

var VFEC_EVENTS = 'vfec/events';
var entity$e = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice$e = /*#__PURE__*/createSlice({
  name: VFEC_EVENTS,
  initialState: /*#__PURE__*/entity$e.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$4.fulfilled, function (state, action) {
      action.payload.events && entity$e.setAll(state, action.payload.events);
    });
  }
});

var getEventsState$4 = function getEventsState(state) {
  return state[VFEC_EVENTS];
};

var _entity$getSelectors$e = /*#__PURE__*/entity$e.getSelectors(getEventsState$4),
    selectAllEvents$4 = _entity$getSelectors$e.selectAll;

var VFEC_GAMES = 'vfec/games';
var entity$f = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  },
  sortComparer: function sortComparer(a, b) {
    return a.sortOrder - b.sortOrder;
  }
});
var slice$f = /*#__PURE__*/createSlice({
  name: VFEC_GAMES,
  initialState: /*#__PURE__*/entity$f.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$4.fulfilled, function (state, action) {
      action.payload.games && entity$f.setAll(state, action.payload.games);
    });
  }
});

var _entity$getSelectors$f = /*#__PURE__*/entity$f.getSelectors(function (state) {
  return state[VFEC_GAMES];
}),
    selectAllGames$4 = _entity$getSelectors$f.selectAll;

var VFEC_OUTCOMES = 'vfec/outcomes';
var entity$g = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$g = /*#__PURE__*/createSlice({
  name: VFEC_OUTCOMES,
  initialState: /*#__PURE__*/entity$g.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$4.fulfilled, function (state, action) {
      action.payload.outcomes && entity$g.setAll(state, action.payload.outcomes);
    });
  }
});

var _entity$getSelectors$g = /*#__PURE__*/entity$g.getSelectors(function (state) {
  return state[VFEC_OUTCOMES];
}),
    selectAllOutcomes$4 = _entity$getSelectors$g.selectAll;

var VTI_SELECTION = 'vti/selection';
var entity$h = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var accessor = _ref.accessor;
    return accessor;
  }
});
var slice$h = /*#__PURE__*/createSlice({
  name: VTI_SELECTION,
  initialState: /*#__PURE__*/entity$h.getInitialState(),
  reducers: {
    setSelection: entity$h.setAll
  }
});

var getSelectionState$2 = function getSelectionState(state) {
  return state[VTI_SELECTION];
};

var setSelection = slice$h.actions.setSelection;

var _entity$getSelectors$h = /*#__PURE__*/entity$h.getSelectors(getSelectionState$2),
    selectSelection$2 = _entity$getSelectors$h.selectAll;

var outcome$5 = /*#__PURE__*/new schema.Entity('outcomes', {}, {
  idAttribute: 'outcomeId'
});
var game$5 = /*#__PURE__*/new schema.Entity('games', {
  gameOutcomes: [outcome$5]
}, {
  idAttribute: 'gameId'
});
var event$5 = /*#__PURE__*/new schema.Entity('event', {
  games: [game$5]
}, {
  idAttribute: 'eventId'
});

var entityFetch$5 = /*#__PURE__*/createAsyncThunk('vti/fetch', /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(eventId) {
    var _yield$getSportEvents, data, _normalize, entities;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSportEvents({})({
              product: 'vti',
              eventId: eventId
            });

          case 2:
            _yield$getSportEvents = _context.sent;
            data = _yield$getSportEvents.data;
            _normalize = normalize(data == null ? void 0 : data.data, event$5), entities = _normalize.entities;
            return _context.abrupt("return", entities);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var fetchOutcome$1 = /*#__PURE__*/createAsyncThunk('vti/custom', /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_ref2) {
    var session, bet, _yield$getOutcomes, data;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            session = _ref2.session, bet = _ref2.bet;
            _context2.next = 3;
            return getOutcomes({
              session: session
            })(bet);

          case 3:
            _yield$getOutcomes = _context2.sent;
            data = _yield$getOutcomes.data;
            return _context2.abrupt("return", head(data == null ? void 0 : data.data));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}());

var VTI_EVENTS = 'vti/events';
var entity$i = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var eventId = _ref.eventId;
    return eventId;
  }
});
var slice$i = /*#__PURE__*/createSlice({
  name: VTI_EVENTS,
  initialState: /*#__PURE__*/entity$i.getInitialState(),
  reducers: {
    upsertEvents: entity$i.upsertMany
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$5.fulfilled, function (state, action) {
      action.payload.event && entity$i.setAll(state, action.payload.event);
    });
  }
});
var upsertEvents = slice$i.actions.upsertEvents;

var getEventsState$5 = function getEventsState(state) {
  return state[VTI_EVENTS];
};

var _entity$getSelectors$i = /*#__PURE__*/entity$i.getSelectors(getEventsState$5),
    selectAllEvents$5 = _entity$getSelectors$i.selectAll;

var VTI_GAMES = 'vti/games';
var entity$j = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var gameId = _ref.gameId;
    return gameId;
  }
});
var slice$j = /*#__PURE__*/createSlice({
  name: VTI_GAMES,
  initialState: /*#__PURE__*/entity$j.getInitialState(),
  reducers: {
    upsertGames: entity$j.upsertMany
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$5.fulfilled, function (state, action) {
      action.payload.games && entity$j.setAll(state, action.payload.games);
    });
  }
});
var upsertGames = slice$j.actions.upsertGames;

var _entity$getSelectors$j = /*#__PURE__*/entity$j.getSelectors(function (state) {
  return state[VTI_GAMES];
}),
    selectAllGames$5 = _entity$getSelectors$j.selectAll;

var VTI_OUTCOMES = 'vti/outcomes';
var entity$k = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var outcomeId = _ref.outcomeId;
    return outcomeId;
  }
});
var slice$k = /*#__PURE__*/createSlice({
  name: VTI_OUTCOMES,
  initialState: /*#__PURE__*/entity$k.getInitialState(),
  reducers: {
    upsertOutcomes: entity$k.upsertMany
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(entityFetch$5.fulfilled, function (state, action) {
      action.payload.outcomes && entity$k.setAll(state, action.payload.outcomes);
    });
  }
});
var upsertOutcomes = slice$k.actions.upsertOutcomes;

var _entity$getSelectors$k = /*#__PURE__*/entity$k.getSelectors(function (state) {
  return state[VTI_OUTCOMES];
}),
    selectAllOutcomes$5 = _entity$getSelectors$k.selectAll;

var _reducer;
var store = /*#__PURE__*/configureStore({
  reducer: (_reducer = {}, _reducer[VDK_EVENTS] = slice$4.reducer, _reducer[VDK_GAMES] = slice$5.reducer, _reducer[VDK_OUTCOMES] = slice$6.reducer, _reducer[VHK_EVENTS] = slice$7.reducer, _reducer[VHK_GAMES] = slice$8.reducer, _reducer[VHK_OUTCOMES] = slice$9.reducer, _reducer[VBL_EVENTS] = slice$a.reducer, _reducer[VBL_GAMES] = slice$b.reducer, _reducer[VBL_OUTCOMES] = slice$c.reducer, _reducer[VFLM_SELECTION] = slice$3.reducer, _reducer[VFLM_EVENTS] = slice.reducer, _reducer[VFLM_GAMES] = slice$1.reducer, _reducer[VFLM_OUTCOMES] = slice$2.reducer, _reducer[VFEC_SELECTION] = slice$d.reducer, _reducer[VFEC_EVENTS] = slice$e.reducer, _reducer[VFEC_GAMES] = slice$f.reducer, _reducer[VFEC_OUTCOMES] = slice$g.reducer, _reducer[VTI_SELECTION] = slice$h.reducer, _reducer[VTI_EVENTS] = slice$i.reducer, _reducer[VTI_GAMES] = slice$j.reducer, _reducer[VTI_OUTCOMES] = slice$k.reducer, _reducer),
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    });
  },
  devTools: {
    name: 'SB-virtuals-desktop'
  }
});

var _excluded$1 = ["children", "competitionId", "matchDay", "homeTeamRemoteId", "awayTeamRemoteId"];

var Event = function Event(_ref) {
  var _event$games2;

  var children = _ref.children,
      competitionId = _ref.competitionId,
      matchDay = _ref.matchDay,
      homeTeamRemoteId = _ref.homeTeamRemoteId,
      awayTeamRemoteId = _ref.awayTeamRemoteId,
      event = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  // Lazy init
  var _useState = useState$1(function () {
    return false;
  }),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var selection = useSelector(selectSelection);
  var isSingle = useSelector(getIsSingleEvent);
  var selectEventGames = useMemo(function () {
    return getEventGames(event, matchDay);
  }, [event, matchDay]);
  var otherGamesCount = useMemo(function () {
    var _event$games$length, _event$games, _selection$length;

    return !isSingle ? ((_event$games$length = event == null ? void 0 : (_event$games = event.games) == null ? void 0 : _event$games.length) != null ? _event$games$length : 0) - ((_selection$length = selection == null ? void 0 : selection.length) != null ? _selection$length : 0) : undefined;
  }, [event == null ? void 0 : (_event$games2 = event.games) == null ? void 0 : _event$games2.length, selection == null ? void 0 : selection.length, isSingle]);
  var statsUrl = useMemo(function () {
    return "/season/" + competitionId + "/h2h/" + homeTeamRemoteId + "/" + awayTeamRemoteId;
  }, [competitionId, homeTeamRemoteId, awayTeamRemoteId]);
  var games = useSelector(selectEventGames);
  var toggleIsOpen = useCallback(function () {
    return setIsOpen(!isOpen);
  }, [isOpen]);
  return React.createElement(React.Fragment, null, children({
    isSingle: isSingle,
    isOpen: isOpen,
    toggleIsOpen: toggleIsOpen,
    otherGamesCount: otherGamesCount,
    games: head(games),
    otherGames: last(games),
    statsUrl: statsUrl
  }));
};

var _excluded$2 = ["children"];

var Game = function Game(_ref) {
  var children = _ref.children,
      game = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var selectGameOutcomes = useMemo(function () {
    return getGameOutcomes(game);
  }, [game]);
  var outcomes = useSelector(selectGameOutcomes);
  return React.createElement(React.Fragment, null, children({
    outcomes: outcomes
  }));
};

var GameLm = /*#__PURE__*/memo(Game);

var useVflm = function useVflm(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var dispatch = useDispatch();

  var _useState = useState$1({
    competition_id: undefined,
    season_nr: undefined,
    match_day: undefined
  }),
      params = _useState[0],
      setParams = _useState[1]; // as a tick to refetch data


  var _useState2 = useState$1({
    servertime: 0
  }),
      tick = _useState2[0],
      setTick = _useState2[1];

  var _useState3 = useState$1(undefined),
      height = _useState3[0],
      setHeight = _useState3[1];

  var events = useSelector(getEvents);

  var _useState4 = useState$1(function () {
    return groups == null ? void 0 : groups.map(function (_ref) {
      var header = _ref.header;
      return header;
    });
  }),
      headers = _useState4[0];

  var _useState5 = useState$1(function () {
    return head(headers);
  }),
      activeTab = _useState5[0],
      setActiveTab = _useState5[1];

  var tabsList = useTabs({
    tabs: headers,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });
  var currentGroup = useMemo(function () {
    return head(groups == null ? void 0 : groups.filter(function (_ref2) {
      var header = _ref2.header;
      return header === activeTab;
    }));
  }, [groups, activeTab]);
  useEffect(function () {
    dispatch(setAllSelections(currentGroup == null ? void 0 : currentGroup.groups));
  }, [currentGroup]);

  var onMessage = function onMessage(_ref3) {
    var data = _ref3.data;
    (data == null ? void 0 : data.setVfMatches) && setParams(data.setVfMatches);
    (data == null ? void 0 : data.setVfStatus) && setTick(data.setVfStatus);

    try {
      var _messageData$setVfHei;

      var _JSON$parse = JSON.parse(data),
          messageData = _JSON$parse.messageData;

      setHeight(messageData == null ? void 0 : (_messageData$setVfHei = messageData.setVfHeight) == null ? void 0 : _messageData$setVfHei.height);
    } catch (error) {}
  };

  var fetch = useCallback(function (season, day) {
    store.dispatch(entityFetch({
      product: 'vflm',
      season: season,
      day: day
    }));
  }, []);
  useEffect(function () {
    var _currentGroup$day;

    params.season_nr && fetch(params.season_nr, (_currentGroup$day = currentGroup == null ? void 0 : currentGroup.day) != null ? _currentGroup$day : params.match_day);
  }, [params.season_nr, params.match_day, tick.servertime, currentGroup == null ? void 0 : currentGroup.day, fetch]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    competitionId: params.competition_id,
    matchDay: params.match_day,
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: undefined,
    height: height,
    events: events,
    groups: currentGroup == null ? void 0 : currentGroup.groups
  };
};

var _excluded$3 = ["games"],
    _excluded2$1 = ["gameOutcomes"];
var getEvents$1 = function getEvents(matchIds) {
  return createSelector(selectAllEvents$4, function (events) {
    return matchIds ? events.filter(function (event) {
      return matchIds.some(function (remoteId) {
        return remoteId === event.remoteId;
      });
    }) : events;
  });
};
var getEventGames$1 = function getEventGames(_ref, matchDay) {
  var games = _ref.games,
      event = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return createSelector([selectAllGames$4, selectSelection$1], function (allGames, selection) {
    return partition(chainFrom(allGames).filter(function (game) {
      return games.some(function (gameId) {
        return gameId === game.gameId;
      });
    }).filter(function (game) {
      return game.matchday ? game.matchday === matchDay : true;
    }).map(function (game) {
      return _extends({}, event, game);
    }).toArray(), function (game) {
      return selection.some(function (_ref2) {
        var accessor = _ref2.accessor,
            argument = _ref2.argument;
        return argument ? game.gameTypeId === accessor && game.argument === argument : game.gameTypeId === accessor;
      });
    });
  });
};
var getGameOutcomes$1 = function getGameOutcomes(_ref3) {
  var outcomes = _ref3.gameOutcomes,
      game = _objectWithoutPropertiesLoose(_ref3, _excluded2$1);

  return createSelector([selectAllOutcomes$4], function (allOutcomes) {
    return chainFrom(allOutcomes).filter(function (outcome) {
      return outcomes.some(function (outcomeId) {
        return outcomeId === outcome.outcomeId;
      });
    }).map(function (outcome) {
      return _extends({}, game, outcome, {
        gameStatus: game.status
      });
    }).toArray();
  });
};

var _excluded$4 = ["children", "isSingle", "matchDay", "competitionId", "homeTeamRemoteId", "awayTeamRemoteId"];

var Event$1 = function Event(_ref) {
  var _event$games2;

  var children = _ref.children,
      isSingle = _ref.isSingle,
      matchDay = _ref.matchDay,
      competitionId = _ref.competitionId,
      homeTeamRemoteId = _ref.homeTeamRemoteId,
      awayTeamRemoteId = _ref.awayTeamRemoteId,
      event = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  // Lazy init
  var _useState = useState$1(function () {
    return false;
  }),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var selection = useSelector(selectSelection$1);
  var selectEventGames = useMemo(function () {
    return getEventGames$1(event, matchDay);
  }, [event, matchDay]);
  var otherGamesCount = useMemo(function () {
    var _event$games$length, _event$games, _selection$length;

    return !isSingle ? ((_event$games$length = event == null ? void 0 : (_event$games = event.games) == null ? void 0 : _event$games.length) != null ? _event$games$length : 0) - ((_selection$length = selection == null ? void 0 : selection.length) != null ? _selection$length : 0) : undefined;
  }, [event == null ? void 0 : (_event$games2 = event.games) == null ? void 0 : _event$games2.length, selection == null ? void 0 : selection.length, isSingle]);
  var statsUrl = useMemo(function () {
    return "/season/" + competitionId + "/h2h/" + homeTeamRemoteId + "/" + awayTeamRemoteId;
  }, [competitionId, homeTeamRemoteId, awayTeamRemoteId]);
  var games = useSelector(selectEventGames);
  var toggleIsOpen = useCallback(function () {
    return setIsOpen(!isOpen);
  }, [isOpen]);
  return React.createElement(React.Fragment, null, children({
    isSingle: isSingle,
    isOpen: isOpen,
    toggleIsOpen: toggleIsOpen,
    otherGamesCount: otherGamesCount,
    games: head(games),
    otherGames: last(games),
    statsUrl: statsUrl
  }));
};

var _excluded$5 = ["children"];

var Game$1 = function Game(_ref) {
  var children = _ref.children,
      game = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var selectGameOutcomes = useMemo(function () {
    return getGameOutcomes$1(game);
  }, [game]);
  var outcomes = useSelector(selectGameOutcomes);
  return React.createElement(React.Fragment, null, children({
    outcomes: outcomes
  }));
};

var GameEc = /*#__PURE__*/memo(Game$1);

var useVfec = function useVfec(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var dispatch = useDispatch();

  var _useState = useState$1({
    match_ids: [],
    competition_id: undefined,
    season_nr: undefined,
    match_day: undefined
  }),
      params = _useState[0],
      setParams = _useState[1]; // as a tick to refetch data


  var _useState2 = useState$1({
    servertime: 0
  }),
      tick = _useState2[0],
      setTick = _useState2[1];

  var _useState3 = useState$1(undefined),
      height = _useState3[0],
      setHeight = _useState3[1];

  var _useState4 = useState$1(function () {
    return groups == null ? void 0 : groups.map(function (_ref) {
      var header = _ref.header;
      return header;
    });
  }),
      headers = _useState4[0];

  var _useState5 = useState$1(function () {
    return head(headers);
  }),
      activeTab = _useState5[0],
      setActiveTab = _useState5[1];

  var tabsList = useTabs({
    tabs: headers,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });
  var currentGroup = useMemo(function () {
    return head(groups == null ? void 0 : groups.filter(function (_ref2) {
      var header = _ref2.header;
      return header === activeTab;
    }));
  }, [groups, activeTab]);
  var selectEvents = useMemo(function () {
    return getEvents$1(currentGroup != null && currentGroup.day ? undefined : params.match_ids);
  }, [currentGroup == null ? void 0 : currentGroup.day, params.match_ids]);
  var events = useSelector(selectEvents);
  var isSingleEvent = useMemo(function () {
    return events.length === 1;
  }, [events.length]);
  useEffect(function () {
    dispatch(setAllSelections$1(currentGroup == null ? void 0 : currentGroup.groups));
  }, [currentGroup]);

  var onMessage = function onMessage(_ref3) {
    var data = _ref3.data;
    (data == null ? void 0 : data.setVfecMatches) && setParams(data.setVfecMatches);
    (data == null ? void 0 : data.setVfStatus) && setTick(data.setVfStatus);

    try {
      var _messageData$setVfHei;

      var _JSON$parse = JSON.parse(data),
          messageData = _JSON$parse.messageData;

      setHeight(messageData == null ? void 0 : (_messageData$setVfHei = messageData.setVfHeight) == null ? void 0 : _messageData$setVfHei.height);
    } catch (error) {}
  };

  var fetch = useCallback(function (season, day) {
    store.dispatch(entityFetch$4({
      product: 'vfec',
      season: season,
      day: day
    }));
  }, []);
  useEffect(function () {
    var _currentGroup$day;

    params.season_nr && fetch(params.season_nr, (_currentGroup$day = currentGroup == null ? void 0 : currentGroup.day) != null ? _currentGroup$day : params.match_day);
  }, [params.season_nr, params.match_day, currentGroup == null ? void 0 : currentGroup.day, tick.servertime, fetch]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    matchIds: params.match_ids,
    competitionId: params.competition_id,
    matchDay: params.match_day,
    isSingleEvent: isSingleEvent,
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: undefined,
    height: height,
    events: events,
    groups: currentGroup == null ? void 0 : currentGroup.groups
  };
};

var _excluded$6 = ["sportId", "eventName"];
var getOutcome = /*#__PURE__*/createSelector([selectAllOutcomes$3], function (allOutcomes) {
  return memoize(function (_ref) {
    var gameOutcomes = _ref.gameOutcomes,
        gameName = _ref.gameName,
        eventId = _ref.eventId,
        eventName = _ref.eventName,
        sportId = _ref.sportId,
        status = _ref.status;
    return gameOutcomes.map(function (outcome) {
      return head(chainFrom(allOutcomes).filter(function (_ref2) {
        var outcomeId = _ref2.outcomeId;
        return outcomeId === outcome;
      }).map(function (item) {
        return _extends({}, item, {
          gameStatus: status,
          gameName: gameName,
          eventId: eventId,
          eventName: eventName,
          sportId: sportId
        });
      }).toArray());
    });
  });
});
var getGame = /*#__PURE__*/createSelector([selectAllEvents$3, selectAllGames$3], function (allEvents, allGames) {
  return memoize(function (accessor) {
    return allEvents.map(function (_ref3) {
      var sportId = _ref3.sportId,
          eventName = _ref3.eventName,
          event = _objectWithoutPropertiesLoose(_ref3, _excluded$6);

      return chainFrom(allGames) // transducer
      .filter(function (_ref4) {
        var eventId = _ref4.eventId;
        return eventId === event.eventId;
      }).filter(function (_ref5) {
        var gameTypeId = _ref5.gameTypeId;
        return gameTypeId === accessor;
      }).map(function (item) {
        return _extends({}, item, {
          sportId: sportId,
          eventName: eventName
        });
      }).toArray();
    });
  });
});
var getGameOutcomes$2 = /*#__PURE__*/createSelector([getGame, getOutcome], function (getGame, outcomes) {
  return memoize(function (accessor) {
    return getGame(accessor).map(function (games) {
      return games.map(outcomes);
    });
  });
});
var getArguments = /*#__PURE__*/createSelector([getGame], function (getGame) {
  return memoize(function (accessor) {
    return getGame(accessor).map(function (games) {
      return games.map(function (_ref6) {
        var argument = _ref6.argument;
        return argument;
      });
    });
  });
});
var getTree = /*#__PURE__*/createSelector([getArguments, getGameOutcomes$2], function (getArguments, getGameOutcomes) {
  return memoize(function (groups) {
    return groups.map(function (_ref7) {
      var header = _ref7.header,
          groups = _ref7.groups;
      return {
        tab: header,
        groups: groups == null ? void 0 : groups.map(function (_ref8) {
          var header = _ref8.header,
              groups = _ref8.groups,
              outcomes = _ref8.outcomes,
              accessor = _ref8.accessor;
          return _extends({}, outcomes ? {
            gameName: header,
            gameOutcomes: outcomes,
            arguments: getArguments(accessor),
            outcomes: getGameOutcomes(accessor)
          } : {
            tab: header,
            groups: groups == null ? void 0 : groups.map(function (_ref9) {
              var header = _ref9.header,
                  outcomes = _ref9.outcomes,
                  accessor = _ref9.accessor;
              return {
                gameName: header,
                gameOutcomes: outcomes,
                arguments: getArguments(accessor),
                outcomes: getGameOutcomes(accessor)
              };
            })
          });
        })
      };
    });
  });
});
var getEvents$2 = /*#__PURE__*/createSelector(selectAllEvents$3, function (events) {
  return events.map(function (_ref10) {
    var eventName = _ref10.eventName,
        eventId = _ref10.eventId,
        sportId = _ref10.sportId;
    return {
      eventName: eventName,
      eventId: eventId,
      sportId: sportId
    };
  });
});

var MethodContext = /*#__PURE__*/createContext(undefined);

var MethodProvider = function MethodProvider(_ref) {
  var children = _ref.children,
      method = _ref.method;
  var value = useMemo(function () {
    return method;
  }, [method]);
  return React.createElement(MethodContext.Provider, {
    value: value
  }, children);
};

var useMethodContext = function useMethodContext() {
  var context = useContext(MethodContext);

  if (context === undefined) {
    throw new Error("'useMethodContext' must be used within a MethodProvider");
  }

  return context;
};

var useMethod = function useMethod() {
  return useMethodContext();
};

var useVbl = function useVbl(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var data = useSelector(function (state) {
    return getTree(state)(groups);
  });
  var dispatch = useDispatch();

  var _useState = useState$1(function () {
    return undefined;
  }),
      height = _useState[0],
      setHeight = _useState[1];

  var events = useSelector(getEvents$2); // Lazy init

  var _useState2 = useState$1(function () {
    var tab = data[0].tab;
    return tab;
  }),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1]; // Lazy init


  var _useState3 = useState$1(function () {
    return data.map(function (_ref) {
      var tab = _ref.tab;
      return tab;
    });
  }),
      tabs = _useState3[0]; // Lazy init


  var _useState4 = useState$1(function () {
    var groups = data[0].groups;
    return groups;
  }),
      dataGroups = _useState4[0],
      setDataGroups = _useState4[1];

  var tabsList = useTabs({
    tabs: tabs,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });
  var addOutcome = useMethod();

  var resolvePlaceBets = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(bets) {
      var outcomes;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (bets) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return Promise.all(bets.map(mapCustomBet).map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(bet) {
                  var _yield$dispatch, payload;

                  return runtime_1.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return dispatch(fetchOutcome(bet));

                        case 2:
                          _yield$dispatch = _context.sent;
                          payload = _yield$dispatch.payload;
                          return _context.abrupt("return", payload);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 4:
              outcomes = _context2.sent;
              outcomes == null ? void 0 : outcomes.map(addOutcome);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function resolvePlaceBets(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var mapCustomBet = function mapCustomBet(_ref4) {
    var matchId = _ref4.matchId,
        unified = _ref4.unified;
    return {
      remoteEventId: matchId,
      remoteGameId: unified.marketId,
      remoteOutcomeType: unified.outcomeId,
      selectionKey: unified.uf_match_id
    };
  };

  var onMessage = function onMessage(_ref5) {
    var data = _ref5.data;
    (data == null ? void 0 : data.setVblMatchday) && fetch(data.setVblMatchday);
    (data == null ? void 0 : data.placeBets) && resolvePlaceBets(data.placeBets);

    try {
      var _messageData$setVblHe;

      var _JSON$parse = JSON.parse(data),
          messageData = _JSON$parse.messageData;

      setHeight(messageData == null ? void 0 : (_messageData$setVblHe = messageData.setVblHeight) == null ? void 0 : _messageData$setVblHe.height);
    } catch (error) {}
  };

  var fetch = function fetch(_ref6) {
    var season = _ref6.season_name,
        day = _ref6.match_day;
    return dispatch(entityFetch$3({
      product: 'vbl',
      season: season,
      day: day
    }));
  };

  useEffect(function () {
    var _data$filter = data.filter(function (_ref7) {
      var tab = _ref7.tab;
      return tab === activeTab;
    }),
        groups = _data$filter[0].groups;

    setDataGroups(groups);
  }, [activeTab, data]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: dataGroups,
    height: height,
    events: events,
    groups: undefined
  };
};

var _excluded$7 = ["header", "groups", "outcomes", "accessor"],
    _excluded2$2 = ["header", "outcomes", "accessor"];
var getEvent = /*#__PURE__*/createSelector([selectAllEvents$1], function (allEvents) {
  return head(allEvents);
});
var getOutcome$1 = /*#__PURE__*/createSelector([selectAllOutcomes$1], function (allOutcomes) {
  return memoize(function (_ref) {
    var gameOutcomes = _ref.gameOutcomes,
        gameName = _ref.gameName,
        eventId = _ref.eventId,
        eventName = _ref.eventName,
        sportId = _ref.sportId;
    return gameOutcomes.map(function (outcome) {
      return head(chainFrom(allOutcomes).filter(function (_ref2) {
        var outcomeId = _ref2.outcomeId;
        return outcomeId === outcome;
      }).map(function (item) {
        return _extends({}, item, {
          gameName: gameName,
          eventId: eventId,
          eventName: eventName,
          sportId: sportId
        });
      }).toArray());
    });
  });
});
var getGame$1 = /*#__PURE__*/createSelector([getEvent, selectAllGames$1], function (event, allGames) {
  return memoize(function (accessor) {
    return chainFrom(allGames) // transducer
    .filter(function (_ref3) {
      var eventId = _ref3.eventId;
      return eventId === (event == null ? void 0 : event.eventId);
    }).filter(function (_ref4) {
      var gameTypeId = _ref4.gameTypeId;
      return gameTypeId === accessor;
    }).map(function (item) {
      return _extends({}, item, {
        sportId: event == null ? void 0 : event.sportId,
        eventName: event == null ? void 0 : event.eventName
      });
    }).toArray();
  });
});
var getGameOutcomes$3 = /*#__PURE__*/createSelector([getGame$1, getOutcome$1], function (getGame, outcomes) {
  return memoize(function (accessor) {
    return head(getGame(accessor).map(outcomes));
  });
});
var getArguments$1 = /*#__PURE__*/createSelector([getGame$1], function (getGame) {
  return memoize(function (accessor) {
    return head(getGame(accessor).map(function (_ref5) {
      var argument = _ref5.argument;
      return argument;
    }));
  });
});
var getTree$1 = /*#__PURE__*/createSelector([getArguments$1, getGameOutcomes$3], function (getArguments, getGameOutcomes) {
  return memoize(function (groups) {
    return groups.map(function (_ref6) {
      var header = _ref6.header,
          groups = _ref6.groups;
      return {
        tab: header,
        groups: groups == null ? void 0 : groups.map(function (_ref7) {
          var header = _ref7.header,
              groups = _ref7.groups,
              outcomes = _ref7.outcomes,
              accessor = _ref7.accessor,
              rest = _objectWithoutPropertiesLoose(_ref7, _excluded$7);

          return _extends({}, outcomes ? _extends({
            gameName: header,
            gameOutcomes: outcomes,
            arguments: getArguments(accessor),
            outcomes: getGameOutcomes(accessor)
          }, rest) : {
            tab: header,
            groups: groups == null ? void 0 : groups.map(function (_ref8) {
              var header = _ref8.header,
                  outcomes = _ref8.outcomes,
                  accessor = _ref8.accessor,
                  rest = _objectWithoutPropertiesLoose(_ref8, _excluded2$2);

              return _extends({
                gameName: header,
                gameOutcomes: outcomes,
                arguments: getArguments(accessor),
                outcomes: getGameOutcomes(accessor)
              }, rest);
            })
          });
        })
      };
    });
  });
});
var WINNER_GAME = -2301;
var getEventDetails = /*#__PURE__*/createSelector([selectAllOutcomes$1], function (allOutcomes) {
  return memoize(function (_ref9) {
    var gameOutcomes = _ref9.gameOutcomes;
    return gameOutcomes.map(function (outcome) {
      return chainFrom(allOutcomes).filter(function (_ref10) {
        var outcomeId = _ref10.outcomeId;
        return outcomeId === outcome;
      }).map(function (_ref11) {
        var outcomeName = _ref11.outcomeName;
        return outcomeName;
      }).joinToString('');
    });
  });
});
var getEvents$3 = /*#__PURE__*/createSelector([selectAllGames$1, getEventDetails], function (games, getEventName) {
  return chainFrom(games).filter(function (_ref12) {
    var gameTypeId = _ref12.gameTypeId;
    return gameTypeId === WINNER_GAME;
  }).map(getEventName).flatten().toArray();
});

var SWITCH_EVENTS = 'switchEvents';
var SET_HEIGHT = 'setHeight';

var useVdk = function useVdk(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var getData = function getData() {
    return getTree$1(store.getState())(groups);
  };

  var _useState = useState$1(getData),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = useState$1(undefined),
      height = _useState2[0],
      setHeight = _useState2[1];

  var unsubscribe = store.subscribe(function () {
    setData(getData);
  });
  var events = getEvents$3(store.getState());

  var _useState3 = useState$1(function () {
    var tab = data[0].tab;
    return tab;
  }),
      activeTab = _useState3[0],
      setActiveTab = _useState3[1];

  var _useState4 = useState$1(function () {
    return data == null ? void 0 : data.map(function (_ref) {
      var tab = _ref.tab;
      return tab;
    });
  }),
      tabs = _useState4[0];

  var _useState5 = useState$1(function () {
    var groups = data[0].groups;
    return groups;
  }),
      dataGroups = _useState5[0],
      setDataGroups = _useState5[1];

  var tabsList = useTabs({
    tabs: tabs,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });

  var onMessage = function onMessage(_ref2) {
    var data = _ref2.data;

    try {
      var _JSON$parse = JSON.parse(data),
          messageType = _JSON$parse.messageType,
          messageData = _JSON$parse.messageData;

      if (messageType === SET_HEIGHT) setHeight(messageData == null ? void 0 : messageData.height);
      if (messageType === SWITCH_EVENTS) fetch(messageData == null ? void 0 : messageData.unified_event_ids);
    } catch (error) {} // Silently ignore

  };

  var fetch = useCallback(function (_ref3) {
    var uglyEventId = _ref3[0];
    var eventId = uglyEventId.slice(uglyEventId.indexOf(':', uglyEventId.indexOf(':') + 1) + 1);
    store.dispatch(entityFetch$1({
      product: 'vdr',
      eventId: eventId
    }));
  }, []);
  useEffect(function () {
    var _data$filter = data.filter(function (_ref4) {
      var tab = _ref4.tab;
      return tab === activeTab;
    }),
        groups = _data$filter[0].groups;

    setDataGroups(groups);
  }, [activeTab, setData, data]);
  useEffect(function () {
    return function () {
      return unsubscribe();
    };
  }, [unsubscribe]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: dataGroups,
    height: height,
    events: events,
    groups: undefined
  };
};

var _excluded$8 = ["header", "groups", "outcomes", "accessor"],
    _excluded2$3 = ["header", "outcomes", "accessor"];
var getEvent$1 = /*#__PURE__*/createSelector([selectAllEvents$2], function (allEvents) {
  return head(allEvents);
});
var getOutcome$2 = /*#__PURE__*/createSelector([selectAllOutcomes$2], function (allOutcomes) {
  return memoize(function (_ref) {
    var gameOutcomes = _ref.gameOutcomes,
        gameName = _ref.gameName,
        eventId = _ref.eventId,
        eventName = _ref.eventName,
        sportId = _ref.sportId;
    return gameOutcomes.map(function (outcome) {
      return head(chainFrom(allOutcomes).filter(function (_ref2) {
        var outcomeId = _ref2.outcomeId;
        return outcomeId === outcome;
      }).map(function (item) {
        return _extends({}, item, {
          gameName: gameName,
          eventId: eventId,
          eventName: eventName,
          sportId: sportId
        });
      }).toArray());
    });
  });
});
var getGame$2 = /*#__PURE__*/createSelector([getEvent$1, selectAllGames$2], function (event, allGames) {
  return memoize(function (accessor) {
    return chainFrom(allGames) // transducer
    .filter(function (_ref3) {
      var eventId = _ref3.eventId;
      return eventId === (event == null ? void 0 : event.eventId);
    }).filter(function (_ref4) {
      var gameTypeId = _ref4.gameTypeId;
      return gameTypeId === accessor;
    }).map(function (item) {
      return _extends({}, item, {
        sportId: event == null ? void 0 : event.sportId,
        eventName: event == null ? void 0 : event.eventName
      });
    }).toArray();
  });
});
var getGameOutcomes$4 = /*#__PURE__*/createSelector([getGame$2, getOutcome$2], function (getGame, outcomes) {
  return memoize(function (accessor) {
    return head(getGame(accessor).map(outcomes));
  });
});
var getArguments$2 = /*#__PURE__*/createSelector([getGame$2], function (getGame) {
  return memoize(function (accessor) {
    return head(getGame(accessor).map(function (_ref5) {
      var argument = _ref5.argument;
      return argument;
    }));
  });
});
var getTree$2 = /*#__PURE__*/createSelector([getArguments$2, getGameOutcomes$4], function (getArguments, getGameOutcomes) {
  return memoize(function (groups) {
    return groups.map(function (_ref6) {
      var header = _ref6.header,
          groups = _ref6.groups;
      return {
        tab: header,
        groups: groups == null ? void 0 : groups.map(function (_ref7) {
          var header = _ref7.header,
              groups = _ref7.groups,
              outcomes = _ref7.outcomes,
              accessor = _ref7.accessor,
              rest = _objectWithoutPropertiesLoose(_ref7, _excluded$8);

          return _extends({}, outcomes ? _extends({
            gameName: header,
            gameOutcomes: outcomes,
            arguments: getArguments(accessor),
            outcomes: getGameOutcomes(accessor)
          }, rest) : {
            tab: header,
            groups: groups == null ? void 0 : groups.map(function (_ref8) {
              var header = _ref8.header,
                  outcomes = _ref8.outcomes,
                  accessor = _ref8.accessor,
                  rest = _objectWithoutPropertiesLoose(_ref8, _excluded2$3);

              return _extends({
                gameName: header,
                gameOutcomes: outcomes,
                arguments: getArguments(accessor),
                outcomes: getGameOutcomes(accessor)
              }, rest);
            })
          });
        })
      };
    });
  });
});
var WINNER_GAME$1 = -2301;
var getEventDetails$1 = /*#__PURE__*/createSelector([selectAllOutcomes$2], function (allOutcomes) {
  return memoize(function (_ref9) {
    var gameOutcomes = _ref9.gameOutcomes;
    return gameOutcomes.map(function (outcome) {
      return chainFrom(allOutcomes).filter(function (_ref10) {
        var outcomeId = _ref10.outcomeId;
        return outcomeId === outcome;
      }).map(function (_ref11) {
        var outcomeName = _ref11.outcomeName;
        return outcomeName;
      }).joinToString('');
    });
  });
});
var getEvents$4 = /*#__PURE__*/createSelector([selectAllGames$2, getEventDetails$1], function (games, getEventDetails) {
  return chainFrom(games).filter(function (_ref12) {
    var gameTypeId = _ref12.gameTypeId;
    return gameTypeId === WINNER_GAME$1;
  }).map(getEventDetails).flatten().toArray();
});

var SWITCH_EVENTS$1 = 'switchEvents';
var SET_HEIGHT$1 = 'setHeight';

var useVhk = function useVhk(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var getData = function getData() {
    return getTree$2(store.getState())(groups);
  };

  var _useState = useState$1(getData),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = useState$1(undefined),
      height = _useState2[0],
      setHeight = _useState2[1];

  var unsubscribe = store.subscribe(function () {
    setData(getData);
  });
  var events = getEvents$4(store.getState());

  var _useState3 = useState$1(function () {
    var tab = data[0].tab;
    return tab;
  }),
      activeTab = _useState3[0],
      setActiveTab = _useState3[1];

  var _useState4 = useState$1(function () {
    return data == null ? void 0 : data.map(function (_ref) {
      var tab = _ref.tab;
      return tab;
    });
  }),
      tabs = _useState4[0];

  var _useState5 = useState$1(function () {
    var groups = data[0].groups;
    return groups;
  }),
      dataGroups = _useState5[0],
      setDataGroups = _useState5[1];

  var tabsList = useTabs({
    tabs: tabs,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });

  var onMessage = function onMessage(_ref2) {
    var data = _ref2.data;

    try {
      var _JSON$parse = JSON.parse(data),
          messageType = _JSON$parse.messageType,
          messageData = _JSON$parse.messageData;

      if (messageType === SET_HEIGHT$1) setHeight(messageData == null ? void 0 : messageData.height);
      if (messageType === SWITCH_EVENTS$1) fetch(messageData == null ? void 0 : messageData.unified_event_ids);
    } catch (error) {} // Silently ignore

  };

  var fetch = useCallback(function (_ref3) {
    var uglyEventId = _ref3[0];
    var eventId = uglyEventId.slice(uglyEventId.indexOf(':', uglyEventId.indexOf(':') + 1) + 1); // "some:data:eventId" => eventId

    store.dispatch(entityFetch$2({
      product: 'vhc',
      eventId: eventId
    }));
  }, []);
  useEffect(function () {
    var _data$filter = data.filter(function (_ref4) {
      var tab = _ref4.tab;
      return tab === activeTab;
    }),
        groups = _data$filter[0].groups;

    setDataGroups(groups);
  }, [activeTab, setData, data]);
  useEffect(function () {
    return function () {
      return unsubscribe();
    };
  }, [unsubscribe]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: dataGroups,
    height: height,
    events: events,
    groups: undefined
  };
};

var _excluded$9 = ["games"],
    _excluded2$4 = ["gameOutcomes"];
var getEvents$5 = /*#__PURE__*/createSelector(selectAllEvents$5, function (events) {
  return events;
});
var getEventId = /*#__PURE__*/createSelector(getEvents$5, function (events) {
  var _head;

  return (_head = head(events)) == null ? void 0 : _head.eventId;
});
var getEventGroups = function getEventGroups(_ref) {
  var games = _ref.games,
      event = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  return createSelector([selectAllGames$5, selectSelection$2], function (allGames, selection) {
    return map(chainFrom(allGames).filter(function (game) {
      return games.some(function (gameId) {
        return gameId === game.gameId;
      });
    }).filter(function (game) {
      return selection.some(function (_ref2) {
        var accessor = _ref2.accessor;
        return game.gameTypeId === accessor;
      });
    }).filter(function (game) {
      return game.status === 255 || game.status === 210;
    }) //TODO
    .map(function (game) {
      return _extends({}, event, game);
    }).toObjectGroupBy(function (_ref3) {
      var gameName = _ref3.gameName;
      return gameName;
    }), function (games, gameName) {
      return {
        gameName: gameName,
        sortOrder: games[0].sortOrder,
        games: games
      };
    });
  });
};
var getGameOutcomes$5 = function getGameOutcomes(_ref4) {
  var outcomes = _ref4.gameOutcomes,
      game = _objectWithoutPropertiesLoose(_ref4, _excluded2$4);

  return createSelector([selectAllOutcomes$5], function (allOutcomes) {
    return chainFrom(allOutcomes).filter(function (outcome) {
      return outcomes.some(function (outcomeId) {
        return outcomeId === outcome.outcomeId;
      });
    }).map(function (outcome) {
      return _extends({}, game, outcome, {
        gameStatus: game.status
      });
    }).toArray();
  });
};

var usePrev = function usePrev(value, initial) {
  var ref = useRef({
    target: value,
    previous: initial
  });

  if (ref.current.target !== value) {
    ref.current.previous = ref.current.target;
    ref.current.target = value;
  }

  return ref.current.previous;
};

var _excluded$a = ["children"];

var Event$2 = function Event(_ref) {
  var children = _ref.children,
      event = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  var selectEventGroups = useMemo(function () {
    return getEventGroups(event);
  }, [event]);
  var groups = useSelector(selectEventGroups);
  return React.createElement(React.Fragment, null, children({
    groups: groups
  }));
};

var _excluded$b = ["children"];

var Game$2 = function Game(_ref) {
  var children = _ref.children,
      game = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  var selectGameOutcomes = useMemo(function () {
    return getGameOutcomes$5(game);
  }, [game]);
  var outcomes = useSelector(selectGameOutcomes);
  return React.createElement(React.Fragment, null, children({
    outcomes: outcomes
  }));
};

var GameTi = /*#__PURE__*/memo(Game$2);

var SWITCH_EVENTS$2 = 'switchEvents';
var SET_HEIGHT$2 = 'setHeight';
var PLACE_BETS = 'placeBets';
var SUBSCRIBE = 'SUBSCRIBE';
var UNSUBSCRIBE = 'UNSUBSCRIBE';
var SNAPSHOT = 'SNAPSHOT';
var SPECIFIERS_DELIMITERS = ['|', '='];

var useVti = function useVti(groups) {
  if (groups === undefined) {
    throw new Error("Missing 'groups' field.");
  }

  var dispatch = useDispatch();

  var _useState = useState$1(function () {
    return undefined;
  }),
      remoteEventId = _useState[0],
      setRemoteEventId = _useState[1];

  var _useState2 = useState$1(function () {
    return undefined;
  }),
      height = _useState2[0],
      setHeight = _useState2[1];

  var events = useSelector(getEvents$5);
  var eventId = useSelector(getEventId);
  var oldEventId = usePrev(eventId);

  var _useState3 = useState$1(function () {
    return groups == null ? void 0 : groups.map(function (_ref) {
      var header = _ref.header;
      return header;
    });
  }),
      headers = _useState3[0];

  var _useState4 = useState$1(function () {
    return head(headers);
  }),
      activeTab = _useState4[0],
      setActiveTab = _useState4[1];

  var tabsList = useTabs({
    tabs: headers,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  });
  var addOutcome = useMethod();
  var currentGroup = useMemo(function () {
    return head(groups == null ? void 0 : groups.filter(function (_ref2) {
      var header = _ref2.header;
      return header === activeTab;
    }));
  }, [groups, activeTab]);

  var resolvePlaceBets = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(bets) {
      var outcomes;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (bets) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return Promise.all(bets == null ? void 0 : bets.map(mapCustomBet).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(bet) {
                  var _yield$dispatch, payload;

                  return runtime_1.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return dispatch(fetchOutcome$1({
                            session: '',
                            bet: bet
                          }));

                        case 2:
                          _yield$dispatch = _context.sent;
                          payload = _yield$dispatch.payload;
                          return _context.abrupt("return", payload);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 4:
              outcomes = _context2.sent;
              outcomes == null ? void 0 : outcomes.map(addOutcome);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function resolvePlaceBets(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var mapCustomBet = function mapCustomBet(_ref5) {
    var event_id = _ref5.event_id,
        market_id = _ref5.market_id,
        market_specifier = _ref5.market_specifier,
        outcome_id = _ref5.outcome_id,
        unified_event_id = _ref5.unified_event_id;
    return {
      remoteEventId: event_id,
      remoteGameId: market_id,
      remoteOutcomeType: outcome_id,
      selectionKey: unified_event_id,
      specifiers: market_specifier.split(SPECIFIERS_DELIMITERS[0]).map(function (item) {
        return item.split(SPECIFIERS_DELIMITERS[1]);
      }).reduce(function (object, _ref6) {
        var _extends2;

        var key = _ref6[0],
            value = _ref6[1];
        return _extends({}, object, (_extends2 = {}, _extends2[key] = value, _extends2));
      }, {})
    };
  };

  useEffect(function () {
    dispatch(setSelection(currentGroup == null ? void 0 : currentGroup.groups));
  }, [currentGroup]); // Trying to decode Betradar's message

  var onMessage = function onMessage(_ref7) {
    var data = _ref7.data;

    try {
      var _JSON$parse = JSON.parse(data),
          messageType = _JSON$parse.messageType,
          messageData = _JSON$parse.messageData;

      if (messageType === SET_HEIGHT$2) setHeight(messageData == null ? void 0 : messageData.height);
      if (messageType === SWITCH_EVENTS$2) setRemoteEventId(head(messageData == null ? void 0 : messageData.event_ids));
      if (messageType === PLACE_BETS) resolvePlaceBets(messageData == null ? void 0 : messageData.bets);
    } catch (error) {} // Silently ignore

  };

  var _useWebSocket = useWebSocket('wss://test.fuksiarz.pl/virtuals-api/ws/virtuals/v1/api/br'),
      sendJsonMessage = _useWebSocket.sendJsonMessage,
      lastJsonMessage = _useWebSocket.lastJsonMessage; // Track eventId updates


  useEffect(function () {
    eventId && sendJsonMessage({
      languageCode: 'pl',
      eventId: eventId,
      operation: SUBSCRIBE,
      product: 'VTI'
    });
  }, [eventId]); // Unsubscribe previous evnetId watcher

  useEffect(function () {
    oldEventId && sendJsonMessage({
      languageCode: 'pl',
      eventId: oldEventId,
      operation: UNSUBSCRIBE,
      product: 'VTI'
    });
  }, [oldEventId]);
  useEffect(function () {
    if (!(lastJsonMessage != null && lastJsonMessage.data)) return;

    var _normalize = normalize(lastJsonMessage.data, event$5),
        _normalize$entities = _normalize.entities,
        event = _normalize$entities.event,
        games = _normalize$entities.games,
        outcomes = _normalize$entities.outcomes;

    lastJsonMessage.data.modelType === SNAPSHOT && event && dispatch(upsertEvents(event));
    games && dispatch(upsertGames(games));
    outcomes && dispatch(upsertOutcomes(outcomes));
  }, [lastJsonMessage]);
  useQuery("vti/fetch/" + remoteEventId, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            remoteEventId && dispatch(entityFetch$5(remoteEventId));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  return {
    onMessage: onMessage,
    tabsList: tabsList,
    activeTab: activeTab,
    data: undefined,
    height: height,
    events: events,
    groups: currentGroup == null ? void 0 : currentGroup.groups
  };
};

var VirtualsSports;

(function (VirtualsSports) {
  VirtualsSports["vflm"] = "vflm";
  VirtualsSports["vfec"] = "vfec";
  VirtualsSports["vbl"] = "vbl";
  VirtualsSports["vti"] = "vti";
  VirtualsSports["vdk"] = "vdk";
  VirtualsSports["vhk"] = "vhk";
})(VirtualsSports || (VirtualsSports = {}));

var styles = {
  events: {
    'data-name': 'events',
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  },
  wrapper: {
    'data-name': 'wrapper',
    style: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  },
  group: {
    'data-name': 'group',
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  outcomes: {
    'data-name': 'outcomes',
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  row: {
    'data-name': 'row',
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  },
  columns: {
    'data-name': 'columns',
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  },
  'v-columns': {
    'data-name': 'v-columns',
    style: {
      display: 'flex',
      flex: '1',
      flexDirection: 'column',
      justifyContent: 'space-around'
    }
  },
  heading: {
    'data-name': 'heading',
    style: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center'
    }
  },
  headers: {
    'data-name': 'headers',
    style: {
      display: 'flex',
      flex: '1',
      justifyContent: 'flex-end'
    }
  },
  scope: {
    'data-name': 'scope',
    style: {
      display: 'flex',
      flex: '1'
    }
  },
  outcome: {
    'data-name': 'outcome',
    style: {
      alignItems: 'center',
      display: 'flex',
      flex: '1',
      justifyContent: 'center'
    }
  },
  argument: {
    'data-name': 'argument',
    style: {
      alignItems: 'center',
      display: 'flex',
      flex: '0.8 0',
      justifyContent: 'center'
    }
  }
};

var Virtuals = function Virtuals(_ref) {
  var _config$vflm, _config$vfec, _config$vbl, _config$vdk, _config$vhk, _config$vti, _virtuals$activeSport, _virtuals$activeSport2, _virtuals$activeSport3, _virtuals$activeSport4;

  var children = _ref.children,
      config = _ref.config;
  if (config === undefined) return null;
  var virtuals = {
    vflm: (config == null ? void 0 : config.vflm) && useVflm(config == null ? void 0 : (_config$vflm = config.vflm) == null ? void 0 : _config$vflm.groups),
    vfec: (config == null ? void 0 : config.vfec) && useVfec(config == null ? void 0 : (_config$vfec = config.vfec) == null ? void 0 : _config$vfec.groups),
    vbl: (config == null ? void 0 : config.vbl) && useVbl(config == null ? void 0 : (_config$vbl = config.vbl) == null ? void 0 : _config$vbl.groups),
    vdk: (config == null ? void 0 : config.vdk) && useVdk(config == null ? void 0 : (_config$vdk = config.vdk) == null ? void 0 : _config$vdk.groups),
    vhk: (config == null ? void 0 : config.vhk) && useVhk(config == null ? void 0 : (_config$vhk = config.vhk) == null ? void 0 : _config$vhk.groups),
    vti: (config == null ? void 0 : config.vti) && useVti(config == null ? void 0 : (_config$vti = config.vti) == null ? void 0 : _config$vti.groups)
  }; // Lazy init

  var _useState = useState$1(function () {
    return head(Object.keys(config));
  }),
      activeSport = _useState[0],
      setActiveSport = _useState[1];

  var iframeUrl = useMemo(function () {
    var _config$activeSport;

    return activeSport && ((_config$activeSport = config[activeSport]) == null ? void 0 : _config$activeSport.url);
  }, [config, activeSport]);
  var sportsList = useTabs({
    tabs: Object.keys(config),
    activeTab: activeSport,
    setActiveTab: setActiveSport
  });
  return React.createElement(React.Fragment, null, children(_extends({}, virtuals[activeSport], {
    sportsList: sportsList,
    activeSport: activeSport,
    tabsList: (_virtuals$activeSport = virtuals[activeSport]) == null ? void 0 : _virtuals$activeSport.tabsList,
    iframeUrl: iframeUrl,
    iframeHeight: (_virtuals$activeSport2 = virtuals[activeSport]) == null ? void 0 : _virtuals$activeSport2.height,
    events: (_virtuals$activeSport3 = virtuals[activeSport]) == null ? void 0 : _virtuals$activeSport3.events,
    styles: styles,
    data: (_virtuals$activeSport4 = virtuals[activeSport]) == null ? void 0 : _virtuals$activeSport4.data
  })));
};

var LOADING = "loading";
var IDLE = "idle";
var READY = "ready";
var ERROR = "error";
var LOAD = "load";

var useScript = function useScript(src) {
  var _useState = useState$1(src ? LOADING : IDLE),
      status = _useState[0],
      setStatus = _useState[1];

  useEffect(function () {
    if (!src) {
      setStatus(IDLE);
      return;
    }

    var script = document.querySelector("script[src=\"" + src + "\"]");

    if (!script) {
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.status = LOADING;
      document.body.appendChild(script);

      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        if (!script) return;
        script.dataset.status = (event == null ? void 0 : event.type) === LOAD ? READY : ERROR;
      };

      script.addEventListener(LOAD, setAttributeFromEvent);
      script.addEventListener(ERROR, setAttributeFromEvent);
    } else {
      script.dataset.status && setStatus(script.dataset.status);
    }

    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus((event == null ? void 0 : event.type) === LOAD ? READY : ERROR);
    };

    script.addEventListener(LOAD, setStateFromEvent);
    script.addEventListener(ERROR, setStateFromEvent);
    return function () {
      if (script) {
        script.removeEventListener(LOAD, setStateFromEvent);
        script.removeEventListener(ERROR, setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};

var outcomesAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var selectionKey = _ref.selectionKey;
    return selectionKey;
  }
});
var fetchOutcome$2 = /*#__PURE__*/createAsyncThunk('outcomes/fetchOutcome', /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2, _ref3) {
    var session, bet, rejectWithValue, _yield$getOutcomes, data;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            session = _ref2.session, bet = _ref2.bet;
            rejectWithValue = _ref3.rejectWithValue;
            _context.next = 4;
            return getOutcomes({
              session: session
            })(bet);

          case 4:
            _yield$getOutcomes = _context.sent;
            data = _yield$getOutcomes.data;
            return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(outcomesAdapter.getInitialState()));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}());
var outcomes = /*#__PURE__*/createSlice({
  name: 'outcomes',
  initialState: /*#__PURE__*/outcomesAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchOutcome$2.fulfilled, function (state, _ref5) {
      var payload = _ref5.payload;
      var outcome = payload[0];
      outcomesAdapter.addOne(state, outcome);
    });
  }
});

var _outcomesAdapter$getS = /*#__PURE__*/outcomesAdapter.getSelectors(),
    selectById = _outcomesAdapter$getS.selectById;

var store$1 = /*#__PURE__*/configureStore({
  reducer: {
    outcomes: outcomes.reducer
  },
  devTools: {
    name: 'SB-virtuals-mobile'
  }
});

var SCRIPT_URL = 'https://vswstaging.betradar.com/ls/mobile/?/bukmacherska/en/page/vsmobile';
var SPECIFIERS_DELIMITERS$1 = ['|', '='];

var useVirtuals = function useVirtuals(_ref) {
  var _ref$container = _ref.container,
      container = _ref$container === void 0 ? '#vsm_app_container' : _ref$container,
      session = _ref.session,
      options = _ref.options;
  // Kick-start script
  var scriptStatus = useScript(process.env.BETRADAR_VIRTUALS_SCRIPT_URL || SCRIPT_URL); // Due to async nature of 'onBetsAdded' both added and removed bets go in one state

  var _useState = useState$1([[], []]),
      bets = _useState[0],
      setBets = _useState[1]; // VSM's method, see docs. Ignore first two params


  var betsChanged = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_, __, betsAdded, betsRemoved) {
      var translatedBets;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([onBetsAdded(betsAdded), onBetsRemoved(betsRemoved)]);

            case 2:
              translatedBets = _context.sent;
              setBets(translatedBets);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function betsChanged(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(); // Save bet in a store then return its outcome


  var onBetsAdded = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(bets) {
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all(bets.map(map).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(bet) {
                  var _yield$store$dispatch, payload, outcome;

                  return runtime_1.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return store$1.dispatch(fetchOutcome$2({
                            session: session,
                            bet: bet
                          }));

                        case 2:
                          _yield$store$dispatch = _context2.sent;
                          payload = _yield$store$dispatch.payload;
                          outcome = payload[0];
                          return _context2.abrupt("return", outcome);

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x6) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onBetsAdded(_x5) {
      return _ref3.apply(this, arguments);
    };
  }(); // Fetch outcomes from the store as VSM`s bets might be missing fields


  var onBetsRemoved = function onBetsRemoved(bets) {
    return bets.map(function (_ref5) {
      var selectionKey = _ref5.selectionKey;
      return selectById(store$1.getState().outcomes, selectionKey);
    });
  }; // Warning: this might change depending on Betradar's implementation


  var map = function map(_ref6) {
    var _unified$specifiers;

    var matchId = _ref6.matchId,
        unified = _ref6.unified,
        selectionKey = _ref6.selectionKey;
    return {
      remoteEventId: matchId,
      remoteGameId: unified == null ? void 0 : unified.marketId,
      remoteOutcomeType: unified == null ? void 0 : unified.outcomeId,
      selectionKey: selectionKey,
      specifiers: unified == null ? void 0 : (_unified$specifiers = unified.specifiers) == null ? void 0 : _unified$specifiers.split(SPECIFIERS_DELIMITERS$1[0]).map(function (item) {
        return item.split(SPECIFIERS_DELIMITERS$1[1]);
      }).reduce(function (object, _ref7) {
        var _extends2;

        var key = _ref7[0],
            value = _ref7[1];
        return _extends({}, object, (_extends2 = {}, _extends2[key] = value, _extends2));
      }, {})
    };
  };

  var __options = _extends({
    betsChanged: betsChanged
  }, options); // Init VSM


  useEffect(function () {
    if (scriptStatus !== READY) return;
    if (vsmobile.instance !== null) return;
    vsmobile.init(container, __options);
  }, [scriptStatus]);
  return bets;
};

var StateContext = /*#__PURE__*/createContext(undefined);
var OutcomesContext = /*#__PURE__*/createContext(undefined);
var SetStateContext = /*#__PURE__*/createContext(undefined);

var StateProvider = function StateProvider(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      _ref$outcomes = _ref.outcomes,
      outcomes = _ref$outcomes === void 0 ? [] : _ref$outcomes,
      events = _ref.events,
      maxSelections = _ref.maxSelections;
  var initState = useMemo(function () {
    return new Array(maxSelections != null ? maxSelections : columns).fill(undefined);
  }, [columns, maxSelections]); // Lazy init state

  var _useState = useState$1(function () {
    return initState;
  }),
      state = _useState[0],
      setState = _useState[1]; // Reset state on game change


  useEffect(function () {
    setState(initState);
  }, ["" + events, initState]);
  return React.createElement(OutcomesContext.Provider, {
    value: outcomes
  }, React.createElement(StateContext.Provider, {
    value: state
  }, React.createElement(SetStateContext.Provider, {
    value: setState
  }, children)));
};

var useOutcomesContext = function useOutcomesContext() {
  var context = useContext(OutcomesContext);

  if (context === undefined) {
    throw new Error("'useOutcomesContext' must be used within a StateProvider");
  }

  return context;
};

var useThisStateContext = function useThisStateContext(index) {
  if (typeof index === 'undefined') return;
  var context = useContext(StateContext);

  if (context === undefined) {
    throw new Error("'useThisStateContext' must be used within a StateProvider");
  }

  return context[index];
};

var useRestStateContext = function useRestStateContext() {
  var context = useContext(StateContext);

  if (context === undefined) {
    throw new Error("'useRestStateContext' must be used within a StateProvider");
  }

  return context.filter(Boolean);
};

var useStateContext = function useStateContext() {
  var context = useContext(StateContext);

  if (context === undefined) {
    throw new Error("'useState' must be used within a StateProvider");
  }

  return context;
};

var useSetStateContext = function useSetStateContext() {
  var dispatch = useContext(SetStateContext);

  if (dispatch === undefined) {
    throw new Error("'useSetState' must be used within a StateProvider");
  }

  return dispatch;
};

var getResults = function getResults() {
  var state = useStateContext();
  var outcomes = useOutcomesContext();
  return outcomes.filter(function (_ref2) {
    var outcomeName = _ref2.outcomeName;
    return outcomeName === state.join(',');
  });
};

var getResult = function getResult() {
  return head(getResults());
};

var getHasResult = function getHasResult() {
  return !!getResults().length;
};

var useState = (function (index) {
  return {
    thisEventName: useThisStateContext(index),
    otherEventNames: useRestStateContext(),
    setState: useSetStateContext(),
    result: getResult(),
    hasResult: getHasResult()
  };
});

var _excluded$c = ["children"];

var Element = function Element(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return React.createElement("div", Object.assign({}, props), children);
};

var styles$1 = function styles(isMultiselect) {
  return {
    'data-name': 'fieldset',
    'data-multiselect': isMultiselect,
    style: {
      display: 'inline-flex'
    }
  };
};

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      _ref$isMultiselect = _ref.isMultiselect,
      isMultiselect = _ref$isMultiselect === void 0 ? false : _ref$isMultiselect,
      _ref$fieldsetElement = _ref.fieldsetElement,
      Wrapper = _ref$fieldsetElement === void 0 ? Element : _ref$fieldsetElement,
      _ref$onOutcomeSelect = _ref.onOutcomeSelect,
      onOutcomeSelect = _ref$onOutcomeSelect === void 0 ? function (outcome) {
    console.log('Adding: ', outcome);
  } : _ref$onOutcomeSelect,
      _ref$offOutcomeSelect = _ref.offOutcomeSelect,
      offOutcomeSelect = _ref$offOutcomeSelect === void 0 ? function (outcome) {
    console.log('Removing: ', outcome);
  } : _ref$offOutcomeSelect;

  var _useState = useState(),
      hasResult = _useState.hasResult,
      result = _useState.result;

  var prevResult = usePrev(result);
  useEffect(function () {
    hasResult ? result && onOutcomeSelect(result) : prevResult && offOutcomeSelect(prevResult);
  }, [result, prevResult, hasResult]);
  return React.createElement(Wrapper, Object.assign({}, styles$1(isMultiselect)), children);
};

var _excluded$d = ["isActive", "isDisabled", "onClick"];

var Checkbox = function Checkbox(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return React.createElement("input", Object.assign({
    type: "checkbox",
    checked: isActive,
    disabled: isDisabled,
    onChange: onClick
  }, rest));
};

var Field = function Field(_ref) {
  var eventName = _ref.eventName,
      index = _ref.index,
      _ref$element = _ref.element,
      Element = _ref$element === void 0 ? Checkbox : _ref$element;

  var _useState = useState(index),
      thisEventName = _useState.thisEventName,
      otherEventNames = _useState.otherEventNames,
      setState = _useState.setState;

  var isActive = useMemo(function () {
    return thisEventName === eventName;
  }, [thisEventName, eventName]);
  var isDisabled = useMemo(function () {
    return !isActive && (!!thisEventName || otherEventNames.includes(eventName));
  }, [otherEventNames, thisEventName, isActive, eventName]);
  var onClick = useCallback(function () {
    setState(function (state) {
      var _Object$assign;

      return Object.assign([], state, (_Object$assign = {}, _Object$assign[index] = isActive ? undefined : eventName, _Object$assign));
    });
  }, [setState, index, eventName, isActive]);
  return React.createElement(Element, {
    isActive: isActive,
    isDisabled: isDisabled,
    onClick: onClick
  });
};

var EventsContext = /*#__PURE__*/createContext(undefined);

var EventsProvider = function EventsProvider(_ref) {
  var children = _ref.children,
      events = _ref.events;
  var value = useMemo(function () {
    return events;
  }, [events]);
  return React.createElement(EventsContext.Provider, {
    value: value
  }, children);
};

var useEventsContext = function useEventsContext() {
  var context = useContext(EventsContext);

  if (context === undefined) {
    throw new Error("'useEventsContext' must be used within a EventsProvider");
  }

  return context;
};

var useEvents = function useEvents() {
  return useEventsContext();
};

var _excluded$e = ["events", "columns", "element", "outcomes", "maxSelections", "columnElement", "rowElement"];
var styles$2 = {
  column: {
    'data-name': 'column',
    style: {
      display: 'flex',
      flex: '1',
      flexDirection: 'column'
    }
  },
  row: {
    'data-name': 'row'
  }
};

var Wrapper = function Wrapper(_ref) {
  var events = _ref.events,
      columns = _ref.columns,
      element = _ref.element,
      outcomes = _ref.outcomes,
      maxSelections = _ref.maxSelections,
      _ref$columnElement = _ref.columnElement,
      Column = _ref$columnElement === void 0 ? Element : _ref$columnElement,
      _ref$rowElement = _ref.rowElement,
      Row = _ref$rowElement === void 0 ? Element : _ref$rowElement,
      fieldset = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return React.createElement(StateProvider, {
    columns: columns,
    outcomes: outcomes,
    events: events,
    maxSelections: maxSelections
  }, React.createElement(Fieldset, Object.assign({}, fieldset, {
    isMultiselect: !!maxSelections
  }), range(maxSelections != null ? maxSelections : columns).map(function (index) {
    return React.createElement(Column, Object.assign({}, styles$2.column, {
      key: index
    }), events.map(function (eventName, eventNameIndex) {
      return React.createElement(Row, Object.assign({}, styles$2.row, {
        key: eventNameIndex
      }), React.createElement(Field, {
        element: element,
        eventName: eventName,
        index: index
      }));
    }));
  })));
};

var index = {
  Fieldset: Wrapper,
  EventsProvider: EventsProvider,
  useEvents: useEvents
};

var CurrentTab = /*#__PURE__*/createContext(undefined);
var Tabs = /*#__PURE__*/createContext(undefined);
var SetCurrentTab = /*#__PURE__*/createContext(undefined);
var SetTabs = /*#__PURE__*/createContext(undefined);

var SwitchProvider = function SwitchProvider(_ref) {
  var children = _ref.children;

  var _useState = useState$1(0),
      currentTab = _useState[0],
      setCurrentTab = _useState[1];

  var _useState2 = useState$1([]),
      tabs = _useState2[0],
      setTabs = _useState2[1];

  return React.createElement(Tabs.Provider, {
    value: tabs
  }, React.createElement(SetTabs.Provider, {
    value: setTabs
  }, React.createElement(CurrentTab.Provider, {
    value: currentTab
  }, React.createElement(SetCurrentTab.Provider, {
    value: setCurrentTab
  }, children))));
};

var useCurrentTabContext = function useCurrentTabContext() {
  var context = useContext(CurrentTab);

  if (context === undefined) {
    throw new Error("'useCurrentTabContext' must be used within a Switch");
  }

  return context;
};

var useSetCurrentTabContext = function useSetCurrentTabContext() {
  var dispatch = useContext(SetCurrentTab);

  if (dispatch === undefined) {
    throw new Error("'useSetCurrentTabContext' must be used within a Switch");
  }

  return function (tab) {
    return dispatch(tab);
  };
};

var useTabsContext = function useTabsContext() {
  var context = useContext(Tabs);

  if (context === undefined) {
    throw new Error("'useTabsContext' must be used within a Switch");
  }

  return context;
};

var useSetTabsContext = function useSetTabsContext() {
  var dispatch = useContext(SetTabs);

  if (dispatch === undefined) {
    throw new Error("'useSetTabsContext' must be within a Switch");
  }

  return dispatch;
};

var useSwitch = function useSwitch() {
  return {
    currentTab: useCurrentTabContext(),
    setCurrentTab: useSetCurrentTabContext(),
    tabs: useTabsContext(),
    setTabs: useSetTabsContext()
  };
};

var Button = function Button(_ref) {
  var text = _ref.text,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick;
  return React.createElement("button", {
    onClick: onClick,
    disabled: isDisabled
  }, text);
};

var Switcher = function Switcher(_ref) {
  var tab = _ref.tab,
      index = _ref.index,
      Element = _ref.element;

  var _useSwitch = useSwitch(),
      currentTab = _useSwitch.currentTab,
      setCurrentTab = _useSwitch.setCurrentTab;

  var isDisabled = useMemo(function () {
    return currentTab === index;
  }, [currentTab, index]);
  var onClick = useCallback(function () {
    setCurrentTab(index);
  }, [setCurrentTab, index]);
  if (!Element) return React.createElement(Button, {
    onClick: onClick,
    isDisabled: isDisabled,
    text: tab
  });
  return React.createElement(Element, {
    onClick: onClick,
    isDisabled: isDisabled,
    text: tab
  });
};

var Tab = function Tab(_ref) {
  var tab = _ref.tab,
      index = _ref.index,
      children = _ref.children;

  var _useSwitch = useSwitch(),
      currentTab = _useSwitch.currentTab,
      setTabs = _useSwitch.setTabs;

  var isCurrent = useMemo(function () {
    return currentTab === index;
  }, [currentTab, index]);
  useEffect(function () {
    // Add tab on mount
    setTabs(function (tabs) {
      return [].concat(tabs, [tab]);
    });
    return function () {
      // Remove tab on unomunt
      setTabs(function (tabs) {
        return tabs == null ? void 0 : tabs.filter(function (t) {
          return t !== tab;
        });
      });
    };
  }, [setTabs, tab]);
  return React.createElement(React.Fragment, null, isCurrent && children);
};

var Switch = function Switch(_ref) {
  var element = _ref.element;

  var _useSwitch = useSwitch(),
      tabs = _useSwitch.tabs;

  return React.createElement(React.Fragment, null, tabs.map(function (tab, index) {
    return React.createElement(Switcher, {
      element: element,
      tab: tab,
      index: index,
      key: index
    });
  }));
};

var index$1 = {
  SwitchProvider: SwitchProvider,
  Switch: Switch,
  Tab: Tab
};

var index$2 = (function (props) {
  return React.createElement(Provider, {
    store: store
  }, React.createElement(Virtuals, Object.assign({}, props)));
});
var Vflm = {
  Event: Event,
  Game: GameLm
};
var Vfec = {
  Event: Event$1,
  Game: GameEc
};
var Vti = {
  Event: Event$2,
  Game: GameTi
};

export default index$2;
export { index as Fields, MethodProvider, index$1 as Tabs, Vfec, Vflm, Vti, useVirtuals as useVirtualsMobile };
//# sourceMappingURL=virtuals.esm.js.map
